import { useParams } from 'react-router-dom';
import getCurrentOrg from './getCurrentOrg';

export default () => {
  const params = useParams();
  const currentUserOrganization = getCurrentOrg();

  return params?.organizationId || currentUserOrganization.id;
};
